import GeneralActions from './general.actions';

import MultiplexRepository from '../repositories/multiplex.repository';

export const REQUEST_MULTIPLEX = 'REQUEST_MULTIPLEX';
export const RECEIVE_MULTIPLEX = 'RECEIVE_MULTIPLEX';
export const FAILURE_MULTIPLEX = 'FAILURE_MULTIPLEX';

function failureMultiplex() {
  return {
    type: FAILURE_MULTIPLEX,
    payload: {}
  };
}

function receiveMultiplex(data) {
  return {
    type: RECEIVE_MULTIPLEX,
    payload: {
      data
    }
  };
}

function requestMultiplex() {
  return {
    type: REQUEST_MULTIPLEX,
    payload: {}
  };
}

function loadData() {
  return (dispatch) => {
    dispatch(GeneralActions.taskStarted());
    dispatch(requestMultiplex());
    MultiplexRepository.getMultiplexList()
      .then((response) => {
        dispatch(GeneralActions.taskDone());
        dispatch(receiveMultiplex(response));
      }, () => {
        dispatch(GeneralActions.taskFailed());
        dispatch(failureMultiplex());
      });
  };
}

export default {
  loadData
};



// WEBPACK FOOTER //
// ./src/actions/multiplex.actions.js